import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

/// Asks before a version is taken out of the library. It names the version, because a title
/// with three of them is exactly where somebody removes the wrong one.
export default function RemoveVersionDialog({
  name,
  detail,
  busy,
  onConfirm,
  onCancel,
}: {
  /// The version to name, or undefined while nothing is being removed.
  name?: string;
  /// What tells it apart: size, resolution.
  detail?: string;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Dialog open={name !== undefined} onClose={busy ? undefined : onCancel} fullWidth maxWidth="xs">
      <DialogTitle>{t('versions.remove.title')}</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ overflowWrap: 'anywhere' }}>
          {detail
            ? t('versions.remove.bodyWithDetail', { name: name ?? '', detail })
            : t('versions.remove.body', { name: name ?? '' })}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          {t('common.cancel')}
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={busy}
          startIcon={busy ? <CircularProgress size={16} color="inherit" /> : undefined}
          onClick={onConfirm}
        >
          {t('versions.remove.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
